import prismicConfig from "../../prismic-demo/config/prismic";
import { sharedCSPDirectives } from "config/utils";

export default {
  default_image_url: "https://placehold.co/150x220",
  available_page_sizes: [16, 16 * 2, 16 * 4],
  mapsKey: "AIzaSyB451F91Eed54R7ToFu8_tzH-0IMyN66YI",
  color_attribute_id: "93",
  website_id: 1,
  tax: 1,
  contentSecurityPolicy: {
    // see https://developer.akamai.com/tools/boomerang#content-security-policy-(csp) for mPulse
    directives: sharedCSPDirectives({
      scriptSrc: [
        "static.payzen.eu",
        "www.paypalobjects.com",
        "*.paypal.com",
        "https://*.go-mpulse.net",
        "https://*.twic.pics",
        ...prismicConfig.csp.scriptSrc,
      ],
      frameSrc: [
        "static.payzen.eu",
        "www.paypalobjects.com",
        "*.paypal.com",
        ...prismicConfig.csp.frameSrc,
      ],
      styleSrc: ["static.payzen.eu"],
      imgSrc: [
        "static.payzen.eu",
        "*.front-commerce.com",
        "www.paypalobjects.com",
        "*.paypal.com",
        "https://*.akstat.io",
        "https://*.twic.pics",
        ...prismicConfig.csp.imgSrc,
      ],
      connectSrc: [
        "www.google-analytics.com",
        "https://*.akstat.io",
        "https://*.go-mpulse.net",
        "www.paypalobjects.com",
        "*.paypal.com",
        ...prismicConfig.csp.connectSrc,
      ],
      baseUri: [...prismicConfig.csp.baseUri],
    }),
  },
  homepage_identifier: "home",
  defaultTitle: "Front-Commerce Magento 1",
  defaultDescription:
    "Demo website featuring Front-Commerce using Magento 1 as a backend.",
  themeColor: "#666699",
  search: {
    dynamicFacetSize: 10,
    ignoredAttributeKeys: [
      "description",
      "name",
      "image",
      "status",
      "tax_class_id",
    ],
    authorizedCategoriesFacet: [],
  },
  phoneNumber: "05 61 40 54 92",
  email: "contact@front-commerce.com",
  rewrittenToRoot: ["/home"],
  useUserTitles: false,
};
